import debounce from 'lodash/debounce';
import toggleClasses from './classes-toggle';

const getParagraphList = () => {
  const allParagraphs = document.querySelectorAll('p');
  return allParagraphs;
};

const originalParagraphs = Array.from(getParagraphList()).map(paragraph =>
  Array.from(paragraph.classList),
);

const changeableParagraphs = getParagraphList();

const handleParagraphClasses = debounce(() => {
  const windowWidth = window.innerWidth;

  const mobilePrefix = 'u--mobileText-';
  const tabletPrefix = 'u--tabletText-';
  const desktopPrefix = 'u--text';

  changeableParagraphs.forEach((p, index) => {
    p.className = ''; // eslint-disable-line no-param-reassign
    p.className = originalParagraphs[index].join(' '); // eslint-disable-line no-param-reassign

    if (windowWidth < 760) {
      if (p.className.includes(mobilePrefix)) {
        toggleClasses([tabletPrefix, desktopPrefix], p);
      }
    }

    if (windowWidth >= 760 && windowWidth < 1024) {
      if (p.className.includes(tabletPrefix)) {
        toggleClasses([mobilePrefix, desktopPrefix], p);
      }
    }

    if (windowWidth >= 1024) {
      toggleClasses([mobilePrefix, tabletPrefix], p);
    }
  });
}, 250);

if (changeableParagraphs.length !== 0) {
  window.addEventListener('DOMContentLoaded', handleParagraphClasses, false);
  window.addEventListener('resize', handleParagraphClasses, false);
}
